export const PRODUCT_SIZE_PICKER_LOADING = 'PRODUCT_SIZE_PICKER_LOADING';
export const PRODUCT_SIZE_PICKER_SELECT = 'PRODUCT_SIZE_PICKER_SELECT';
export const PRODUCT_SIZE_PICKER_ERROR = 'PRODUCT_SIZE_PICKER_ERROR';
export const PRODUCT_SIZE_PICKER_DATA = 'PRODUCT_SIZE_PICKER_DATA';